module.exports = __webpack_public_path__ + "img/logo-white-icon-hat.faa8152.png";